import { render, staticRenderFns } from "./SliceText.vue?vue&type=template&id=8aa1ec3e&scoped=true"
import script from "./SliceText.vue?vue&type=script&lang=js"
export * from "./SliceText.vue?vue&type=script&lang=js"
import style0 from "./SliceText.vue?vue&type=style&index=0&id=8aa1ec3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa1ec3e",
  null
  
)

export default component.exports